(function () {
    'use strict';

    angular
        .module('app.dailyLogs')
        .controller('DailyLogsEntryController', DailyLogsEntryController);

    DailyLogsEntryController.$inject = ['$scope', '$state', '$stateParams', 'common', 'dataservice', 'attachmentService'];
    /* @ngInject */
    function DailyLogsEntryController($scope, $state, $stateParams, common, dataservice, attachmentService) {
        var vm = this;

        vm.title = "Log Entry"
        vm.item = [];
        vm.isLoading = true;
        vm.onDate = common.getMainState("mainDate");
        vm.cancel = cancel;
        vm.save = save;
        vm.saveButtonText = "Save";
        vm.saveButtonIcon = "fa-save";
        vm.isSaving = false;

        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function cancel() {
            $state.go("dailylogs.list");
        }
        
        function getItems() {
            var entryId = $stateParams.id;
            var logTypeId = $stateParams.logTypeId;
            

            return dataservice.getItems('api/DailyLogs/EntryForLogType/' + logTypeId + '/' + entryId).then(function (response) {
                vm.item = response.data;
                var ht = vm.item.HelpText;
                if (ht != null) {
                    ht = ht.replace("<a", "<a target='_blank'");
                    vm.item.HelpText = ht;
                }
                
                if (vm.item.SendOnNewEntry) {
                    vm.saveButtonText = "Save and Send";
                    vm.saveButtonIcon = "fa-send";
                }
                else {
                    vm.saveButtonText = "Save";
                    vm.saveButtonIcon = "fa-save";
                }
                
                if (entryId <= 0) {
                    vm.item.DisplayOn = moment(common.getMainState("mainDate")).format("YYYY-MM-DD");
                    vm.item.LogTypeId = logTypeId;
                }
                else {
                    
                    for (var i = 0; i < vm.item.Questions.length; i++) {
                        if (vm.item.Questions[i].AnswerType == "6") {
                            if (vm.item.Questions[i].Answer) {
                                vm.item.Questions[i].Answer = moment(vm.item.Questions[i].Answer).toDate();
                            }
                        }
                    }
                }
                common.setAuditInfo(vm.item);
                return vm.item;
            }, function (error) { });
        }



        function validate(isFinal) {
            if (!vm.item.Entry) {
                common.logger.error("Log Entry is required");
                return false;
            }
            if (isFinal) {
                for (var i = 0; i < vm.item.Questions.length; i++) {
                    var q = vm.item.Questions[i];

                    if (q.AnswerType == 8) {
                        var sig = q.accept();
                        q.Answer = sig.dataUrl;
                    }

                    if (q.AnswerType == 7) {

                        var tp = 'timePicker' + q.ID;
                        if (vm.dailyLogForm[tp].$invalid) {

                            common.logger.error(q.Question + " must be a valid time");
                            return false;
                        }
                    }

                    if (q.AnswerType == 6) {
                        var dp = 'datePicker' + q.ID;
                        if (vm.dailyLogForm[dp].$invalid) {
                            common.logger.error(q.Question + " must be a valid date");
                            return false;
                        }
                    }


                    if (q.Required) {
                        if (q.AnswerType == 4) {
                            var isItemSelected = false;
                            for (var j = 0; j < q.Items.length; j++) {
                                if (q.Items[j].Selected) {
                                    isItemSelected = true;
                                    break;
                                }
                            }
                            if (!isItemSelected) {
                                common.logger.error(q.Question + " must have at least one item selected");
                                return false;
                            }
                        }
                        else {
                            if (!q.Answer) {
                                common.logger.error(q.Question + " is required");
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        }

        function save(sendOnSave) {
            
            if (!vm.isSaving) {
                vm.isSaving = true;
                if (validate(sendOnSave)) {
                    var parentType = "LogEntry";
                    
                    dataservice.saveItem('api/DailyLogs/SaveEntry', vm.item).then(function (saveResult) {
                    
                        var savedEntry = saveResult.data;
                        common.convertDateStringsToDates(savedEntry);
                        attachmentService.upload(parentType, savedEntry.ID, savedEntry).then(function (result) {
                            var requestDto = { Data: savedEntry.ID };
                            vm.isSaving = false;

                            if (sendOnSave) {
                                dataservice.saveItem('api/DailyLogs/SendMessageForNewLogEntry', requestDto, true).then(function () {
                                    $state.go("dailylogs.list");
                                }, function () { });
                            }
                            else {
                                $state.go("dailylogs.list");
                            }

                        }, function (error) { });

                    }).catch(function (error) {

                    });
                }
                vm.isSaving = false;
            }
        }
    }
})();
